<!--
 * @Descripttion:
 * @Author: linwc
 * @Date: 2025-07-15 17:58:33
 * @LastEditors: linwc
 * @LastEditTime: 2025-08-11 09:58:03
-->
<template>
  <div id="app">
    <a-config-provider :locale="locale">
      <router-view />
    </a-config-provider>
  </div>
</template>

<script>
// import { colors_light } from '@/theme/colors_light.js';
// import { colors_lysora_dark } from '@/theme/colors_dark.js';
import { mapGetters } from 'vuex';

// const colorItems = [
//   {
//     value: colors_light,
//     name: '亮色'
//   },
//   {
//     value: colors_lysora_dark,
//     name: '暗色'
//   }
// ];

export default {
  name: 'App',
  created() {
    // this.setSkin(0);
  },
  data() {
    return {
      overHide: false
    };
  },
  computed: {
    ...mapGetters(['language']),
    locale() {
      return this.$i18n.getLocaleMessage(this.language).antLocale;
    }
  },
  methods: {
    // 换肤
    setSkin(index) {
      // this.$store.commit('SkinStore/setSkin', colorItems[index].value);
    }
  }
};
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  /* -webkit-font-smoothing: antialiased; */
  /* -moz-osx-font-smoothing: grayscale; */
  /* color: #2c3e50; */
  height: 100%;
  box-sizing: border-box;
}
</style>
